import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {EntityAssetViewModel} from '../view-models/entity-asset.view-model';

@Component({
    selector: 'app-entity-asset-card',
    templateUrl: './entity-asset-card.component.html',
    styleUrls: ['./entity-asset-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityAssetCardComponent {
    public readonly entityAsset = input.required<EntityAssetViewModel>();
    public readonly cardClicked = output<EntityAssetViewModel>();

    handleClick(_event: Event): void {
        this.cardClicked.emit(this.entityAsset());
    }
}
